/* eslint-disable no-restricted-syntax */
import { StorageAdapter } from "@civic/storage-adapter";
import PriorityStore from "./PriorityStore";
import IPFSStore from "./IPFSStore";
import schema from "./profileSchema.json";
import { StorageLocation } from "./types";
import { PublicIdentityStore } from "./CentralIdentityStore";
const create = (did, resolver, civicIdentityStoreEndpoint) => {
    const priorityStore = new PriorityStore([
        PublicIdentityStore.create(did, civicIdentityStoreEndpoint),
        new IPFSStore(did, resolver),
    ]);
    const config = {
        storageMapping: {},
        storageLocation: {
            [StorageLocation.Store]: priorityStore,
        },
        schema,
    };
    return new StorageAdapter(config);
};
export { create };
